import React, { useState } from "react";
import { styled } from "@mui/material/styles";
import MuiAccordion from "@mui/material/Accordion";
import MuiAccordionSummary from "@mui/material/AccordionSummary";
import MuiAccordionDetails from "@mui/material/AccordionDetails";
import Typography from "@mui/material/Typography";
import { Box, Container, useMediaQuery } from "@mui/material";
import { ArrowForwardIosRounded } from "@mui/icons-material";
import { theme } from "../App";
import { navbarBlue } from "../Classes/theme";
import { NAVBAR_SPACE } from "./Navbar/Navbar";


const Accordion = styled((props) => (
    <MuiAccordion disableGutters elevation={0} square {...props} />
))(({ theme }) => ({
    border: `1px solid ${theme.palette.divider}`,
    "&:not(:last-child)": {
        borderBottom: 0,
    },
    "&:before": {
        display: "none",
    },
}));

const AccordionSummary = styled((props) => (
    <MuiAccordionSummary
        sx={{
            backgroundColor: "#fbfbfb",
            borderLeft: "none",
        }}
        expandIcon={
            <ArrowForwardIosRounded
                sx={{
                    fontSize: "19px",
                    transform: "rotate(90deg)",
                    color: navbarBlue,
                    fontWeight: "bold",
                }}
            />
        }
        {...props}
    />
))(({ theme }) => ({
    backgroundColor: "#fbfbfb",
    borderLeft: "none",
    flexDirection: "row",
    "& .MuiButtonBase-root.MuiAccordionSummary-root": {
        backgroundColor: "#fbfbfb",
        borderLeft: "none",
    },
    "& .MuiAccordionSummary-expandIconWrapper.Mui-expanded": {
        transform: "rotate(90deg)",
    },
    "& .MuiAccordionSummary-content": {},
}));

const AccordionDetails = styled(MuiAccordionDetails)(({ theme }) => ({
    padding: theme.spacing(2),
    borderTop: "1px solid rgba(0, 0, 0, .125)",
}));



export default function OftenAsked({
    appPageData,
    sxTitle = {},
    sxContainer = {},
}) {
    const spaceTitle = useMediaQuery(theme.breakpoints.down("md"));
    const [move, setMove] = useState(null);

    return (
        <div>
            <Container
                maxWidth="lg"
                sx={{
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "center",
                    px: NAVBAR_SPACE,
                    my: '80px',
                    ...sxContainer,
                }}
            >
                <Typography
                    variant="big"
                    sx={{
                        pb: "60px",
                        ...sxTitle,
                    }}
                >
                    Časté dotazy
                </Typography>
                {appPageData.oftenAsked.map((data, index) => (
                    <Accordion
                        key={`OftenAskedAccI` + index}
                        sx={{
                            backgroundColor: "#fbfbfb",
                            borderLeft: "none",
                            borderRight: "none",
                        }}
                        onMouseEnter={() => {
                            setMove({ index });
                        }}
                        onMouseLeave={() => {
                            if (move?.index === index) {
                                setMove(null);
                            }
                        }}
                    >
                        <AccordionSummary
                            expandIcon={
                                <ArrowForwardIosRounded
                                    sx={{
                                        fontSize: "19px",
                                        color: navbarBlue,
                                        fontWeight: "bold",
                                        transition: "transform 0.2s ease",
                                        transform:
                                            move?.index === index
                                                ? "translateX(5px)"
                                                : "translateX(0px)",
                                    }}
                                />
                            }
                            aria-controls={`often-asked${index}`}
                            id={`often-asked-header${index}`}
                        >
                            <Typography
                                variant="help"
                                sx={{
                                    textAlign: "left",
                                }}
                            >
                                {data.title}
                            </Typography>
                        </AccordionSummary>
                        <AccordionDetails>
                            <Typography sx={{ textAlign: "left" }}>{data.text}</Typography>
                        </AccordionDetails>
                    </Accordion>
                ))}
            </Container>
        </div>
    );
}
